module.exports = __webpack_public_path__ + "static/media/animal-sheep1.012a83f0.aac";